import React, { useRef, useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import CustomCalendar from '@shared/custom-calendar';
import './edit-schedule-dialog-exclusions.scss';

const Exclusions = ({ exceptions, maxDate, minDate, onExcludeDate, weekdays }) => {
  const leftCalendarRef = useRef(null);
  const rightCalendarRef = useRef(null);

  const handleExcludeDate = useCallback(date => {
    onExcludeDate(date);
  }, [onExcludeDate]);

  const handleMonthChange = useCallback(months => {
    if (leftCalendarRef.current) {
      leftCalendarRef.current.onMonthChange(months);
    }
    if (rightCalendarRef.current) {
      rightCalendarRef.current.onMonthChange(months);
    }
  }, []);

  const calendarProps = {
    exceptions,
    maxDate,
    minDate,
    onExcludeDate: handleExcludeDate,
    onMonthChange: handleMonthChange,
    weekdays
  };

  return (
    <div styleName="exclusions-dual-calendar-container">
      <CustomCalendar
        dualPosition="left"
        ref={leftCalendarRef}
        {...calendarProps}
      />
      <CustomCalendar
        dualPosition="right"
        ref={rightCalendarRef}
        {...calendarProps}
      />
    </div>
  );
};

Exclusions.propTypes = {
  exceptions: PropTypes.array,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
  onExcludeDate: PropTypes.func,
  weekdays: PropTypes.array
};

export default memo(Exclusions);
